// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3zwGV","head":"Table_head__35JM0","col":"Table_col__1k3v1"};